import { createContext, useContext, useEffect, useState } from "react";
import { getDropdownConfiguration } from "../modules/ConfigurationModule/services/PartsConfigurationService";
import { getDropdownData } from "../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../globals/globals";



const DropdownsContext = createContext();

const DropdownsProvider = ({ children, noPreloadOpts }) => {

  const [dropdownsData, setDropdownsData] = useState([]);
  const [dropdownIds, setDropdownIds] = useState([]);
  const [dropdownDefaultOptions, setDropdownDefaultOptions] = useState({});
  const [dropdownIdxData, setDropdownIdxData] = useState({})

  useEffect(() => {

    Promise.all(dropdownIds.map(id => getDropdownConfiguration(id))).then(responses => {
      if (responses.every(r => r.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS)) {
        setDropdownsData(responses.map(responseItem => responseItem.data.load))
        // Promise.all(dropdownIds.filter(id => !(noPreloadOpts?.includes(id))).map(id => getDropdownData(id, "", [], 0, 15).then(response => [id, response.data.load]))).then(response => {
        //   setDropdownDefaultOptions(Object.fromEntries(response));
        // });
      }
    });

   
  }, [dropdownIds]);

  useEffect(() => {
  }, [dropdownIdxData])

  useEffect(() => {
    setDropdownIdxData(Object.fromEntries(dropdownsData.map(item => [item.id, item])));
  }, [dropdownsData])

  return (
    <DropdownsContext.Provider value={{ dropdownsData, setDropdownsData, setDropdownIds, dropdownDefaultOptions, dropdownIdxData }}>
      {children}
    </DropdownsContext.Provider>
  )

}

export { DropdownsContext, DropdownsProvider }


export const useDropdownConfig = (dropdownId) => {
  const dropdownContext = useContext(DropdownsContext);
  const config = dropdownContext.dropdownIdxData[dropdownId];
  return { dropdownContext, config }
};